/**
 * @file    TableHeaderInfo.tsx
 * @scope   VIEW
 * @summary Question subtitle + summary stats, or the bolded base-size line when there is no
 *          subtitle. Shared by DynamicTable and DynamicTableOld.
 * @consumes SummaryStats, boldNumbersInString
 * @produces JSX only
 * @sideEffects None.
 */
import React from 'react';
import SummaryStats from 'components/SummaryStats/SummaryStats';
import { boldNumbersInString } from 'core-ui/BoldNumberInString/boldNumbersInString';
import { getOneQuestionSubTitle } from 'helpers/utilities';

export interface TableHeaderInfoProps {
  rawData?: { [key: string]: any };
  stats: any;
  customWidgetConfig: any;
  controllerNameValue: string;
  chartView: boolean;
  showTotals: boolean;
}

/** WHY: TierPerformance hides its base size in chart view only. */
const shouldShowBaseSize = (rawData: any, hasSubtitle: boolean, ctrl: string, chartView: boolean) =>
  !!rawData?.baseSize &&
  !rawData?.subTitle &&
  !hasSubtitle &&
  (ctrl !== 'TierPerformance' || (ctrl === 'TierPerformance' && !chartView));

const TableHeaderInfo: React.FC<TableHeaderInfoProps> = ({
  rawData,
  stats,
  customWidgetConfig,
  controllerNameValue,
  chartView,
  showTotals,
}) => {
  const oneQuestionSubTitle = getOneQuestionSubTitle(customWidgetConfig);
  const hasOneQuestionSubTitle = oneQuestionSubTitle !== null;

  return (
    <>
      {rawData?.subTitle?.length || hasOneQuestionSubTitle ? (
        <div>
          <div id="qLongText" className="question-text">
            {rawData?.subTitle || oneQuestionSubTitle}
          </div>
          {rawData?.baseSize ? (
            <SummaryStats stats={stats} baseSize={rawData?.baseSize}></SummaryStats>
          ) : null}
        </div>
      ) : null}
      {shouldShowBaseSize(rawData, hasOneQuestionSubTitle, controllerNameValue, chartView) ? (
        <span className="base-size-span">
          <span
            dangerouslySetInnerHTML={{
              __html: boldNumbersInString(rawData?.baseSize, showTotals),
            }}
          ></span>
        </span>
      ) : null}
    </>
  );
};

export default React.memo(TableHeaderInfo);
